import axios, {InternalAxiosRequestConfig} from "axios";

const getApiUrl = (): string => {
    return JSON.parse(window.localStorage.getItem("tenant") || "")?.api_url || process.env.REACT_APP_API;
};

const getAuthToken = (): string => {
    return JSON.parse(window.localStorage.getItem("user") || "")?.token || "";
};

const handleErrorResponse = (error: any): Promise<any> => {
    const response = error.response;
    const redirectTo = process.env.REACT_APP_URL;

    if (response.status === 401) {
        //user is not authenticated, redirect to the login page
        window.localStorage.setItem("globalErrorCode", "A006");
        window.location.href = `${redirectTo}/logout`;
    } else if (response.status === 409) {
        //user has the email unverified, redirect to the email verification page
        window.location.href = `${redirectTo}/email/verify`;
    } else if (response.status === 403) {
        //the user is unauthenticated, logout
        window.location.href = `${redirectTo}/logout`;
    } else if (response.status === 404) {
        window.location.href = `${redirectTo}/`;
    }

    return Promise.reject(error);
};

const axiosClient = axios.create({
    // baseURL: process.env.REACT_APP_API,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

axiosClient.interceptors.response.use(
    response => response,
    handleErrorResponse
);

axiosClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const token = getAuthToken();
    config.baseURL = getApiUrl();
    config.headers!.Authorization = token;
    return config;
});

export const authInterceptor = axios.interceptors.request.use(config => {
    config.baseURL = getApiUrl();
    return config;
});

export default axiosClient;
